import D1Ccmr from './D1Ccmr.component';

export default D1Ccmr;
